import React, { useState, useEffect } from 'react';
import { getBanners, deleteBanner } from '../../services/adminApi';
import BannerForm from './BannerForm';
import './BannersList.css';

const BannersList = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingBanner, setEditingBanner] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  useEffect(() => {
    loadBanners();
  }, []);

  const loadBanners = async () => {
    try {
      setLoading(true);
      const data = await getBanners();
      setBanners(data);
    } catch (error) {
      console.error('Error loading banners:', error);
      alert('Не удалось загрузить баннеры');
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedBanners = [...banners].sort((a, b) => {
    if (!sortConfig.key) return 0;

    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    // Handle special cases
    if (sortConfig.key === 'ACTIVE') {
      aValue = a.ACTIVE === 'Y' ? 1 : 0;
      bValue = b.ACTIVE === 'Y' ? 1 : 0;
    }

    // Handle string comparison
    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
    }
    if (typeof bValue === 'string') {
      bValue = bValue.toLowerCase();
    }

    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return '↕️';
    }
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Вы уверены, что хотите удалить этот баннер?')) {
      return;
    }

    try {
      await deleteBanner(id);
      loadBanners();
    } catch (error) {
      console.error('Error deleting banner:', error);
      alert('Не удалось удалить баннер');
    }
  };

  const handleEdit = (banner) => {
    setEditingBanner(banner);
    setShowForm(true);
  };

  const handleCreate = () => {
    setEditingBanner(null);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingBanner(null);
    loadBanners();
  };

  if (loading) {
    return <div className="loading">Загрузка баннеров...</div>;
  }

  return (
    <div className="banners-list">
      <div className="list-header">
        <h2>Баннеры</h2>
        <button onClick={handleCreate} className="btn-primary">+ Добавить баннер</button>
      </div>

      {showForm && (
        <BannerForm
          banner={editingBanner}
          onClose={handleFormClose}
        />
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th 
                className="sortable" 
                onClick={() => handleSort('NAME')}
                style={{ cursor: 'pointer', userSelect: 'none' }}
              >
                Название {getSortIcon('NAME')}
              </th>
              <th>Изображение</th>
              <th 
                className="sortable" 
                onClick={() => handleSort('ACTIVE')}
                style={{ cursor: 'pointer', userSelect: 'none' }}
              >
                Активен {getSortIcon('ACTIVE')}
              </th>
              <th 
                className="sortable" 
                onClick={() => handleSort('SORT')}
                style={{ cursor: 'pointer', userSelect: 'none' }}
              >
                Сортировка {getSortIcon('SORT')}
              </th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {sortedBanners.map((banner) => (
              <tr key={banner.ID}>
                <td>{banner.ID}</td>
                <td>{banner.NAME}</td>
                <td>
                  {banner.PREVIEW_PICTURE_SRC && (
                    <img 
                    src={`${process.env.REACT_APP_BACKEND_URL || 'https://www.kapussta.com'}${banner.PREVIEW_PICTURE_SRC}`}
                      alt={banner.NAME}
                      className="thumbnail"
                    />
                  )}
                </td>
                <td>
                  <span className={`status ${banner.ACTIVE === 'Y' ? 'active' : 'inactive'}`}>
                    {banner.ACTIVE === 'Y' ? 'Активен' : 'Неактивен'}
                  </span>
                </td>
                <td>{banner.SORT}</td>
                <td>
                  <button onClick={() => handleEdit(banner)} className="btn-edit">Редактировать</button>
                  <button onClick={() => handleDelete(banner.ID)} className="btn-delete">Удалить</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BannersList;
